import { SvgIcon, SvgIconProps } from '@mui/material';

const DocumentIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="doc.fill">
        <path
          id="doc.fill_2"
          d="M6.65402 16.5583H13.3463C14.696 16.5583 15.3929 15.8489 15.3929 14.4929V8.87416H10.6844C9.89969 8.87416 9.52302 8.49749 9.52302 7.71275V2.9541H6.65402C5.31055 2.9541 4.60742 3.6635 4.60742 5.02581V14.4929C4.60742 15.8489 5.31055 16.5583 6.65402 16.5583ZM10.8037 7.95759H15.3301C15.2924 7.66881 15.0852 7.39886 14.7588 7.06613L11.3248 3.58817C11.0109 3.268 10.7284 3.05455 10.4396 3.01688V7.59347C10.4459 7.83831 10.5652 7.95759 10.8037 7.95759Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default DocumentIcon;
